export const totalAmount = (arr) => {
  const amount = arr.reduce((acc, curr) => acc + Number(curr.price), 0);
  return amount;
};
